import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { EMPTY_OPTION } from '~/components/FormComponents/constants';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { useCurrenciesQuery } from '~/queries/useCurrenciesQuery';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { commonStyles } from '~/theme/styles/commonStyles';

const CurrencyList = () => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'currency',
  });
  const currency: (TAutocompleteOption | null)[] = useWatch({ control, name: 'currency' });
  const { currencyOptions } = useCurrenciesQuery();

  return (
    <>
      {fields.map((item, index) => (
        <FormGridItem key={item.id} sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
          <FormAutocomplete
            name={`currency.${index}`}
            notNullable
            options={currencyOptions.filter(
              (option) => !currency.some((item) => item?.value === option.value)
            )}
            label="Валюта рахунку"
            inputProps={{
              placeholder: 'Оберіть валюту',
            }}
            disabled={!index}
            fullWidth
          />
          <AddRemoveBlock
            add={() => append(EMPTY_OPTION)}
            remove={() => remove(index)}
            isPlusShown={fields.length < currencyOptions.length}
            isMinusShown={index > 0}
            sx={{ mt: '12px' }}
            blockName={`currency.${index}`}
          />
        </FormGridItem>
      ))}
    </>
  );
};

export default CurrencyList;
